import { CountriesEnum } from "./Countries";

export enum ZoneCountry {
  Brazil = "UTC-03 (SaoPaulo)",
  Chile = "UTC-04 (Santiago)",
  Mexico = "UTC-06 (Ciudad de México)",
  Ecuador = "UTC-05 (Bogota, Quito, Lima)",
}

export const TIMEZONE_COUNTRY: Map<string, string> = new Map()
  .set(`${CountriesEnum.COLOMBIA}`, "America/Bogota")
  .set(`${CountriesEnum.ECUADOR}`, "America/Guayaquil")
  .set(`${CountriesEnum.PERU}`, "America/Lima")
  .set(`${CountriesEnum.CHILE}`, "America/Santiago")
  .set(`${CountriesEnum.MEXICO}`, "America/Mexico_City")
  .set(`${CountriesEnum.BRAZIL}`, "America/Sao_Paulo")
  .set(`${CountriesEnum.EL_SALVADOR}`, "America/El_Salvador")
  .set(`${CountriesEnum.PANAMA}`, "America/Panama")
  .set(`${CountriesEnum.COSTA_RICA}`, "America/Managua")
  .set("", "America/Guayaquil");
